import { createReducer } from 'redux-act';
import {
  fetchPropertyAvailabilitySuccess,
  fetchPropertyAvailabilityFailure,
  setLoading,
  fetchPropertyAvailability,
  clearResults,
  setFilters,
  clearFilters,
} from './propertyAvailabilityActions';

const defaultFilters = {
  classicRewards: false,
  depositPay: false,
  freeCancellation: false,
};

const initialState = {
  roomTypes: [],
  isLoading: true,
  error: null,
  filters: defaultFilters,
};

export const reducer = createReducer(
  {
    [fetchPropertyAvailability]: (state) => ({ ...state, error: null, isLoading: true }),
    [fetchPropertyAvailabilitySuccess]: (state, { roomTypes, meta }) => ({
      ...state,
      roomTypes,
      meta,
    }),
    [fetchPropertyAvailabilityFailure]: (state, error) => ({ ...state, roomTypes: [], meta: {}, error }),
    [clearResults]: (state) => ({ ...state, roomTypes: [], meta: {} }),
    [setLoading]: (state, isLoading) => ({ ...state, isLoading }),
    [setFilters]: (state, filter) => ({ ...state, filters: { ...state.filters, ...filter } }),
    [clearFilters]: (state) => ({ ...state, filters: defaultFilters }),
  },
  initialState,
);
